import React from "react";

// Define the props for the component
interface AddItemButtonProps {
  onClick: () => void; // The onClick function prop
  label: string;
  size?: "small" | "medium" | "large"; // The size prop
}

const AddItemButton: React.FC<AddItemButtonProps> = ({
  onClick,
  label,
  size,
}) => {
  size = size || "medium"; // Set the default value for the size prop

  var length = "w-48"; // Set the default value for the length variable
  if (size === "small") {
    length = "w-36";
  }
  if (size === "medium") {
    length = "w-48";
  }
  if (size === "large") {
    length = "w-60";
  }

  return (
    <button
      className={`relative flex items-center justify-center ${length} h-10 border rounded-lg cursor-pointer bg-primary border-primary group hover:bg-primary active:bg-primary active:border-primary`}
      onClick={onClick}
    >
      <span className="text-base font-semibold text-white transition-all duration-300 ease-in-out group-hover:invisible group-hover:translate-x-20">
        {label}
      </span>
      <span className="absolute right-0 flex items-center justify-center w-10 h-full transition-all duration-300 ease-in-out transform rounded-lg bg-primary group-hover:translate-x-0 group-hover:w-full">
        <svg
          className="w-8 text-white svg"
          fill="none"
          height="24"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line x1="12" x2="12" y1="5" y2="19"></line>
          <line x1="5" x2="19" y1="12" y2="12"></line>
        </svg>
      </span>
    </button>
  );
};

export default AddItemButton;
